<template>
  <div :class="['anchor-menu', anchorMenuFixed ? 'anchor-menu-fixed' : '']">
    <ul :class="'width'+menuData.length">
      <li v-for="(item, index) in menuData" :key="index" @click="handleClick(item, index)">
        <div class="icon" :style="{'backgroundImage':'url('+ item.icon +')'}"></div>
        <div :class="['title', active === item.anchor ? 'active' : '']" v-text="item.title"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "index",
  computed: {
    ...Vuex.mapGetters([
      'anchorMenuFixed'
    ]),
  },
  props: {
    menuData: {
      anchor: '',
      icon: '',
      title: ''
    },
    active: {
      default: ''
    }
  },
  methods: {
    handleClick(data, index) {
      if (this.$listeners['onClick']) {
        this.$emit('onClick', data, index)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .anchor-menu {
    width: 100%;
    height: 90px;
    background: #FFFFFF;
    flex(row, wrap, center, center);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
    position: relative;

    & ul {
      flex(row, nowrap, space-between, center);

      & li {
        cursor: pointer;
        flex(column, nowrap, center, center);

        & .icon {
          width: 36px;
          height: 36px;
          background-size: cover;
        }
        & .title {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.85);
        }
        & .active {
          color: #0072FF;
          border-bottom: 1px solid #0072FF
        }
      }
    }

    & .width3 {
      width: 548px;
    }

    & .width4 {
      width: 850px;
    }

    & .width5 {
      width: 844px;
    }

    & .width6 {
      width: 956px;
    }

    & .width2 {
      width: 334px;
    }

    & .width9 {
      width: 1200px;
    }
  }

  .anchor-menu-fixed {
    top: 0;
    left: 0;
    z-index: 20;
    position: fixed;
  }
</style>
